/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
// see moss new layout


 

$(document).ready(function(){
$('.logo_inner').slick({
    autoplay: true,
    speed: 140,
    loop: true,
    slidesToShow: 4, 
    slideToScroll: 1,
    centerMode: false,
    responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3
      },
       breakpoint: 576,
      settings: {
        slidesToShow: 2
      }
    }
    
  ]
  });

$('.product-slider').slick({
      autoplay: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      arrows: false,
      dots: false,
        asNavFor: '.product-slider-thumbnail',
       prevArrow:"<img class='a-left control-c prev slick-prev' src='https://uploads-ssl.webflow.com/62beeea6730d343d6e1865b8/62bf2786a936f883d12c77fb_arrow-prev.svg'>",
        nextArrow:"<img class='a-right control-c next slick-next' src='https://uploads-ssl.webflow.com/62beeea6730d343d6e1865b8/62bf2786bb1c73044bf96b1a_arrow-next.svg'>"
    });
    $('.product-slider-thumbnail').slick({
      autoplay: false,
      loop: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product-slider',
      dots: false,
      arrows: false,
      focusOnSelect: true,
      variableWidth: false,
       responsive: [
      {
      breakpoint: 480,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
    });
  
    $('.reviews-slider').slick({
     fade: true,
      cssEase: 'linear',
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      prevArrow:"<img class='a-left control-c prev slick-prev' src='https://uploads-ssl.webflow.com/6307a1df88a6bdf191effef2/6307ec17b6064f301fba16ba_prev.svg'>",
      nextArrow:"<img class='a-right control-c next slick-next' src='https://uploads-ssl.webflow.com/6307a1df88a6bdf191effef2/6307ec173982ecedf0f76a7f_next.svg'>",
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 560,
          settings: {
          arrows: false,
          dots: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
$(document).ready(function() {
    $('label.purchase-op-field').click(function() {
        $('label.purchase-op-field').removeClass('op-active');
        $(this).addClass('op-active');
    });
    $(".categories-tab-link.w-inline-block.w-tab-link").on("click", function (event) {
       event.preventDefault();
       return false;
    });     
});


/* functions to fix Accessibility for color contrast ratio thresholds */
$(document).ready(function() {
    // Loop through all elements with the class .owl-dot
    $('.owl-dot').each(function(index) {
      // Add an aria-label attribute with a unique label for each element
      $(this).attr('aria-label', 'Slide ' + (index + 1));
    });
    // Loop through all elements with the class .item
    $('.item').each(function() {
      // Find the img tag inside the current .item element
      var $img = $(this).find('img');
      
      // Check if the img tag has no alt attribute or if the alt attribute is empty
      if (!$img.attr('alt')) {
        // Add a generic alt attribute
        $img.attr('alt', 'Product slide image');
      }
    });

    // Adding Reviews Slider Image Alt Text
    $('.reviews-slider').each(function() {
      // Find the img tag inside the current .item element
      var $img = $(this).find('img');
      
      // Check if the img tag has no alt attribute or if the alt attribute is empty
      if (!$img.attr('alt')) {
        // Add a generic alt attribute
        $img.attr('alt', 'Reviews slide image');
      }
    });

    // Find all elements with the specified class
    var $QuantitySelector__Button = $('button.QuantitySelector__Button');
  
    // Loop through each element
    $QuantitySelector__Button.each(function() {
      // Check if the aria-label attribute is not added or is empty
      if (!$(this).attr('aria-label')) {
        // Handle the case where aria-label is not added or is empty
        $(this).attr('aria-label',  'Quantity Selector Button');
      }
    });

    // Find all elements with the specified class
    var $zpa_btn_custom_btn = $('button.zpa-btn-custom.zpa-carousel-thumbnails__btn');
  
    // Loop through each element
    $zpa_btn_custom_btn.each(function() {
      // Check if the aria-label attribute is not added or is empty
      if (!$(this).attr('aria-label')) {
        // Handle the case where aria-label is not added or is empty
        $(this).attr('aria-label',  'Zapta Variant Select Button');
      }
    });


    // Adding area label to footer social links
    var $ShareButtons__Item_facebook = $('.ShareButtons__Item--facebook');
    var $ShareButtons__Item_twitter = $('.ShareButtons__Item--twitter');
    var $ShareButtons__Item_pinterest = $('.ShareButtons__Item--pinterest');
    var $ToolbarLinks = $('.ArticleToolbar .HorizontalList__Item.Text--subdued.Link');
  
  
    // Loop through each element
    $ShareButtons__Item_facebook.each(function() {
      // Check if the aria-label attribute is not added or is empty
      if (!$(this).attr('aria-label')) {
        // Handle the case where aria-label is not added or is empty
        $(this).attr('aria-label',  'Facebook');
      }
    });
    $ShareButtons__Item_twitter.each(function() {
      // Check if the aria-label attribute is not added or is empty
      if (!$(this).attr('aria-label')) {
        // Handle the case where aria-label is not added or is empty
        $(this).attr('aria-label',  'Twitter');
      }
    });
    $ShareButtons__Item_pinterest.each(function() {
      // Check if the aria-label attribute is not added or is empty
      if (!$(this).attr('aria-label')) {
        // Handle the case where aria-label is not added or is empty
        $(this).attr('aria-label',  'Pinterest');
      }
    });
    $ToolbarLinks.each(function() {
      // Check if the aria-label attribute is not added or is empty
      if (!$(this).attr('aria-label')) {
        // Handle the case where aria-label is not added or is empty
        $(this).attr('aria-label',  'Social Link');
      }
    });  
  
});

$(window).bind('load', function() {
    setTimeout(function(){
      // console.log('loaded');
      // Loop through all elements with the class .item
      $('.zpa-carousel-img-item, .zpa-carousel-thumbnails__image').each(function() {
        // Find the img tag inside the current .item element
        var $img = $(this).find('img');
        
        // Check if the img tag has no alt attribute or if the alt attribute is empty
        if (!$img.attr('alt')) {
          // Add a generic alt attribute
          $img.attr('alt', 'Product slide image');
        }
      });
    }, 500);
});  